import type { LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

export const businessCaseStudiesOR4 = (
  localePartialUrl: string,
): LandingPageTestimonial[] => [
  {
    action: {
      messageKey: 'business_case_study_action',
      link: `https://ouraring.com/blog${localePartialUrl}shane-heath-mud-wtr/`,
    },
    company: 'MUD/WTR',
    id: 'shane-heath',
    image: {
      alt: 'business_image_mudwtr_alt',
      src: 'blue-sky/oura-for-business/business-mudwtr.png',
    },
    name: 'Shane Heath, Founder',
    quote: 'business_case_study_quote',
    tag: 'business_case_study_title',
  },
  {
    action: {
      messageKey: 'business_case_study_action',
      link: `https://ouraring.com/blog${localePartialUrl}all-hours-with-oura-jalen-brunson/`,
    },
    company: 'New York Knicks',
    id: 'jalen-brunson',
    image: {
      alt: 'personal_insights_image_alt_3',
      src: 'business/basket-ball-oreo.jpg',
    },
    name: 'Jalen Brunson, Knicks Guard',
    quote: 'business_human_performance_article_quote',
    tag: 'business_human_performance_article_eyebrow',
  },
];
